<div class="row mb-2">
  <div class="col pl-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-body widget-body pb-0 pt-2 mb-4">
        <div class="row" *ngIf="global.globalAgencyId == 0">
          <div style="text-align: center" class="col-lg-12">
            <label style="color: #ff0000; font-weight: bolder"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
              agency to
              view details</label>
          </div>
        </div>
        <!-- gridBatchData -->
        <ejs-grid #gridBatch [dataSource]="BatchData | async" [allowResizing]="true" allowPaging="true"
          [pageSettings]="initialPage" [allowFiltering]="true" [allowSorting]="true"
          (actionBegin)="onActionComplete($event)" (actionComplete)="test($event)" [filterSettings]="filterSettings"
          (dataStateChange)="dataStateChange($event)" [showColumnChooser]="true" (resizeStop)="onResizeBatch($event)">
          <e-columns>
            <e-column minWidth="200" headerText="Action" uid="action" textAlign="center" [showInColumnChooser]="false">
              <ng-template #template let-data>
                <button class="btn btn-edit-table text-center me-2" (click)="downloadBatchFile(data)">
                  <i class="fa fa-download"></i>
                </button>

                <!-- <button class="btn btn-edit-table mr-2 text-center" (click)="pdfView(data)">
                  <i class="fa fa-eye"></i>
                  Old
                </button> -->
                <button class="btn btn-edit-table  text-center" (click)="GenerateReport(data)">
                  <i class="fa fa-eye"></i>
                  
                </button>
              </ng-template>
            </e-column>
            <e-column minWidth="200" field="batchno" type="string" headerText="Batch No." [allowSorting]="false">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>

            <e-column minWidth="200" field="claimStatus" headerText="Claim Status" type="string"
              [allowFiltering]="false">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth="200" field="clearingHouseName" headerText="Clearing House" type="string"
              [allowFiltering]="false">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth="200" field="createDate" type="date" headerText="Generated Date"
            [allowFiltering]="false"
              [format]="formatOptions"></e-column>
            <e-column minWidth="50" [showInColumnChooser]='false'>
              <ng-template #headerTemplate let-data>
                <div class="d-none d-lg-block">
                  <span id='show' (click)='showColumn()'><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                </div>
              </ng-template>
            </e-column>
          </e-columns>

        </ejs-grid>
        <div *ngIf="BatchListData.length == 0" class="text-center" style="color:red">
          <p>No data available</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ...........................................View 837 Report............................... -->
<span id="open837Modal" data-bs-toggle="modal" data-bs-target="#View837"></span>
<div class="modal fade modalbackgrod" id="View837" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
  data-bs-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">{{ReportHeader}}</h5>
        <div class="text-right">
          <button class="btn blue-btn btn-sm mr-2" (click)="close837Modal()"> Close</button>
        </div>
      </div>
      <div class="modal-body" style="height:600px">
        <ng-container *ngIf="ReportView== true" >
          <div style="width: 100%;height:100%" class="report-border" #reportContainer></div>
        </ng-container>
      </div>
    </div>
  </div>
</div>